import { createSelector } from '@reduxjs/toolkit';
import { AppState } from '../modules';

export const selectModals = createSelector(
  (state: AppState) => state.modals,
  (modals) => modals.list,
);
